<p-toast></p-toast>
<p-fieldset>
    <p-header class="article-title">
      <span class="article-title">Relatório de Aniversariantes - Clientes</span>
      <div class="header-buttons">
        <button class="fab-button primary" (click)="exportTable()" label="Exportar"
              pTooltip="A exportação será de acordo com os filtros selecionados" tooltipPosition="left">
                    <i class="pi pi-file"></i>
                </button>
      </div>
    </p-header>
    <form class="filters" style="min-width: 10px;min-height: 100px;">
        <div class="filter-row">
            <div class="form-control" style="min-width: 100px;min-height: 100px;">
                <label>{{'FIRST-NAME' | translate}}</label>
                <input pInputText type="text" [(ngModel)]="filters.name" name="filters.name">
            </div>
            
            <div class="form-control" style="min-width: 10px;min-height: 10px;">
                <label>Grupo</label>
                <p-dropdown [options]="groupOptions" [(ngModel)]="filters.groupName" name="filters.groupName"
                    appendTo="body" [showClear]="false">
                </p-dropdown>
            </div>

            <div class="form-control" style="min-width: 10px;min-height: 10px;">
                <label>Gênero</label>
                <p-dropdown [options]="genderOptions" [(ngModel)]="filters.gender" name="filters.gender"
                appendTo="body" [showClear]="false">
                </p-dropdown>
            </div>
            
            <div class="form-control" style="min-width: 10px;min-height: 10px;">
                <label>{{'STATUS' | translate}}</label>
                <p-dropdown [options]="active" [(ngModel)]="filters.active" name="filters.active"
                appendTo="body">
                </p-dropdown>
            </div>

            
            
            <div class="form-control" style="min-width: 10px;min-height: 10px;">
                <label>Idade Mínima</label>
                <p-dropdown [options]="ageOptions" [(ngModel)]="filters.minAge" name="filters.minAge"
                    appendTo="body" [showClear]="false">
                </p-dropdown>
            </div>
            
            <div class="form-control" style="min-width: 10px;min-height: 10px;">
                <label>Idade Máxima</label>
                <p-dropdown [options]="ageOptions" [(ngModel)]="filters.maxAge" name="filters.maxAge"
                    appendTo="body" [showClear]="false">
                </p-dropdown>
            </div>
            <div class="form-control" style="min-width: 300px;">
                <label>Período - (O ano não será considerado)</label>
                <p-calendar 
                    dateFormat="dd/mm" 
                    name="dateRange" 
                    [monthNavigator]="true" 
                    appendTo="body"
                    [yearNavigator]="false" 
                    selectionMode="range" 
                    [(ngModel)]="dateRange"
                    [minDate]="minBirthdayDate"
                    [maxDate]="maxBirthdayDate"
                    [showIcon]="true"
                    [readonlyInput]="true"
                    panelStyleClass="birthday-calendar-panel"
                    (onSelect)="normalizeDateRangeYear()">
                </p-calendar>
            </div>
            
        </div>    
    </form>
    <div class="filters filter-grid">
        <div class="filter-row">
            <div class="buttons">
                <div class="form-button">
                    <button class="danger easymarine" (click)="clearFilters()" type="reset">{{ 'CLEAR' | translate }}</button>
                </div>
                <div class="form-button">
                    <button class="primary easymarine" (click)="getCustomerBirthday()" type="submit">{{ 'FIND' | translate }}</button>
                </div>
            </div>
        </div>   

    </div>
    
    <div style="padding: 15px 0; text-align: right; font-weight: bold; font-size: 14px; color: #495057;">
        Total de aniversariantes encontrados: {{birthdays.length}}
    </div>

    <div class="table">
        <p-table [value]="birthdays" id="birthdaysTable" #shippingFiles [resizableColumns]="true" [autoLayout]="true"
        sortMode="multiple" [rows]="10" [paginator]="true" [pageLinks]="5" [rowsPerPageOptions]="[10,20,30,50,100]">
            <ng-template pTemplate="header">
                <tr>
                    <th class="text-center" [pSortableColumn]="'name'">{{'NAME' | translate}} <p-sortIcon [field]="'name'"></p-sortIcon></th>
                    <th [pSortableColumn]="'birthday'">{{'DATE-BIRTH' | translate}}<p-sortIcon [field]="'birthday'"></p-sortIcon></th>
                    <th [pSortableColumn]="'age'">Idade<p-sortIcon [field]="'age'"></p-sortIcon></th>
                    <th [pSortableColumn]="'gender'">Gênero<p-sortIcon [field]="'gender'"></p-sortIcon></th>
                    <th [pSortableColumn]="'groupName'">Grupo<p-sortIcon [field]="'groupName'"></p-sortIcon></th>
                    <th [pSortableColumn]="'phone'">{{'PHONE' | translate}}<p-sortIcon [field]="'phone'"></p-sortIcon></th>
                    <th [pSortableColumn]="'email'">{{'EMAIL' | translate}}<p-sortIcon [field]="'email'"></p-sortIcon></th>
                    <th [pSortableColumn]="'active'">{{'STATUS' | translate}}<p-sortIcon [field]="'active'"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-file let-index="rowIndex">
                <tr>
                    <td>
                        {{ file.name }}
                    </td>
                    <td>
                        {{ file.birthday | date: 'dd/MM/yyyy'}}
                    </td>
                    <td>
                        {{ file.age }}
                    </td>
                    <td>
                        {{ translateGender(file.gender) }}
                    </td>
                    <td>
                        {{ file.groupName }}
                    </td>
                    <td>
                        {{ file.phone }}
                    </td>
                    <td>
                        {{ file.email }}
                    </td>
                    <td>
                        <span *ngIf="file.active" class="badge badge-pill success" style="cursor: default;">{{ 'ACTIVE' | translate }}</span>
                        <span *ngIf="!file.active"
                            class="badge badge-pill danger" style="cursor: default;">{{ 'INACTIVE' | translate }}</span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>

